import type { ButtonHTMLAttributes, ReactNode } from 'react';

export interface FilterChipProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  selected?: boolean;
  children: ReactNode;
}

export function FilterChip({ selected = false, className = '', children, ...props }: FilterChipProps) {
  return (
    <button
      type="button"
      className={`ui-chip ${selected ? 'selected' : ''} ${className}`.trim()}
      aria-pressed={selected}
      {...props}
    >
      {children}
    </button>
  );
}
